import { grey } from '@mui/material/colors'

const useStyles = {
  thumbnail: {
    width: '98px',
    height: '98px',
    objectFit: 'cover' as const,
    borderRadius: '100px',
    marginBottom: '8px',
  },
  preview: {
    width: '100%',
    height: '347px',
    objectFit: 'cover' as const,
    backgroundColor: grey[100],
  },
  fullPhotoLoader: {
    width: '200px',
  },
  newPhoto: { width: '100%', height: '374px', objectFit: 'cover' as const },
  loader: { marginTop: 0 },
  dropzone: {
    borderRadius: 0.5,
    padding: 2,
    marginBottom: '1px',
    textAlign: 'center',
    width: '100%',
    backgroundColor: 'transparent',
    // Match dashed border to Figma design
    backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23EBEBEB' stroke-width='1' stroke-dasharray='5%2c 5' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
  },
  dropzoneActive: {
    backgroundColor: grey[100],
    backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%239E9E9E' stroke-width='1' stroke-dasharray='5%2c 5' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
    marginBottom: '1px',
  },
  cropperContainer: { position: 'relative', width: '100%', height: 400, background: '#333' },
}
export default useStyles
